export class SocketIoSetupEventListeners {
  static readonly type = '@SocketIoState.setupEventListeners';
}

export class SocketIoJoinChat {
  static readonly type = '@SocketIoState.joinChat';
  constructor(public chatId: string) {}
}

export class SocketIoLeaveChat {
  static readonly type = '@SocketIoState.leaveChat';
  constructor(public chatId: string) {}
}
